import { TFunction } from "i18next";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";
import { RiContactsFill } from "react-icons/ri";
import { MdCampaign } from "react-icons/md";
import React from "react";
import { LuFileText, LuImage, LuVideo } from "react-icons/lu";
import { WhatsappBusinessApiHeaderType } from "@whatslly/types/waba/WhatsappBusinessApiTemplate";

export const getNavMenuTabs = (t: TFunction, hideBulkMessages?: boolean) => {
  const tabs = [
    {
      id: `chats`,
      tooltip: t("whatsapp_business_api_agent_page.nav_options.chats"),
      icon: <SvgV2 iconName={`chat-now`} width={20} height={20} />,
    },
    {
      id: `contacts`,
      tooltip: t("whatsapp_business_api_agent_page.nav_options.contacts"),
      icon: <RiContactsFill />,
    },
  ];
  if (!hideBulkMessages) {
    tabs.push({
      id: `campaigns`,
      tooltip: t("whatsapp_business_api_agent_page.nav_options.campaigns"),
      icon: <MdCampaign />,
    });
  }
  return tabs;
};

export const DOCUMENT_SIZE_LIMIT_BYTES = 100_000_000; //100MB
const PHOTO_SIZE_LIMIT_BYTES = 5_000_000; //5MB
const VIDEO_SIZE_LIMIT_BYTES = 16_000_000; //16MB

export const VIDEO_ACCEPT_FILE_TYPES = ["video/mp4", "video/3gp"];
export const PHOTO_ACCEPT_FILE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/avif", "image/tiff"];
export const DOCUMENT_ACCEPT_FILE_TYPES = [
  "text/plain",
  "application/pdf",
  "application/vnd.ms-powerpoint",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

export const PHOTOS_VIDEO_ACCEPT_FILE_TYPES = [...VIDEO_ACCEPT_FILE_TYPES, ...PHOTO_ACCEPT_FILE_TYPES];
export const ALL_ACCEPT_FILE_TYPES = [...PHOTOS_VIDEO_ACCEPT_FILE_TYPES, ...DOCUMENT_ACCEPT_FILE_TYPES];

export const ALL_ACCEPT_FILE_TYPES_SIZE_MAP = ALL_ACCEPT_FILE_TYPES.reduce<Record<string, number>>((all, type) => {
  if (VIDEO_ACCEPT_FILE_TYPES.includes(type)) {
    all[type] = VIDEO_SIZE_LIMIT_BYTES;
  }
  if (PHOTO_ACCEPT_FILE_TYPES.includes(type)) {
    all[type] = PHOTO_SIZE_LIMIT_BYTES;
  }
  if (DOCUMENT_ACCEPT_FILE_TYPES.includes(type)) {
    all[type] = DOCUMENT_SIZE_LIMIT_BYTES;
  }
  return all;
}, {});

export const MEDIA_HEADER_ICONS: Record<string, React.ElementType> = {
  IMAGE: LuImage,
  VIDEO: LuVideo,
  DOCUMENT: LuFileText,
};

export const getMediaAccept = (headerType: WhatsappBusinessApiHeaderType) => {
  switch (headerType) {
    case "IMAGE":
      return PHOTO_ACCEPT_FILE_TYPES.join(",");
    case "VIDEO":
      return VIDEO_ACCEPT_FILE_TYPES.join(",");
    case "DOCUMENT":
      return DOCUMENT_ACCEPT_FILE_TYPES.join(",");
    default:
      return "";
  }
};
